import {ApiProtectedWS as http} from "../api/axios";
import {baseURL} from "../util/Constants";

class ConfigInstanceService {

  getReportPrivacy() {
    return http?.get(baseURL.activitiesapi.config + '/reportPrivacy');
  }

  updateReportPrivacy(hideUserInfoInReports: boolean) {
    return http?.put(baseURL.activitiesapi.config + '/reportPrivacy', { hideUserInfoInReports });
  }

  updateViewDetailUserWindows(see:string) {  
    return http?.get(baseURL.activitiesapi.config + `/viewDetail?see=` + see,);
  }
}

export default ConfigInstanceService;
